export default "__VITE_ASSET__CEirBFZk__"